/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    Heading,
    ContentContainerBodyShift,
    FlexRow,
    FlexCol,
    Accordion,
    Text,
    TextBlock,
} from 'sarsaparilla';

import { lotteryAccordionItems } from 'site-kit';

export default function HowTheLotteriesWorkAccordion() {
    return (
        <section id="how-lotteries-work" className="lottery-full-width-bg">
            <ContentContainerBodyShift>
                <FlexRow hasGutters={false}>
                    <FlexCol>
                        <Heading
                            headingLevel={2}
                            hasUnderline="left"
                            appearance="h3"
                            className="lottery-section-header"
                        >
                            How the Lotteries Work
                        </Heading>
                    </FlexCol>
                </FlexRow>

                <TextBlock width="xl">
                    <Text size="lg" className="mb-3">
                        {process.env.SITE_NAME} offers two types of lotteries - a standard
                        lottery and an early access lottery. All lotteries are randomized
                        by shuffling the applications, which produces an unbiased and
                        random ordering of results.
                    </Text>
                    <Accordion
                        id="lottery-accordion"
                        className="ml-1"
                        items={lotteryAccordionItems}
                        gaTrackingId="55464654654"
                    />
                </TextBlock>
            </ContentContainerBodyShift>
        </section>
    );
}
